const titleMap = {
  xxl: 'h1-lg',
  xl: 'h1',
  lg: 'h2',
  md: 'h3',
  sm: 'h4',
  xs: 'h5'
}

export const buildHeadingMixin = propName => ({
  props: {
    [propName]: {
      type: Object,
      required: true
    }
  },
  computed: {
    [`${propName}Size`] () {
      return titleMap[this[propName].size || 'xl']
    }
  }
})

export default buildHeadingMixin('heading')